<template>
	<NuxtLink :to="logoLink">
		<slot />
	</NuxtLink>
</template>

<script setup>
	const config = useAppConfig();
	const {getLang} = useLang();
	const logoLink = computed(() => {
		const currLanguage = getLang();
		return config.lang == currLanguage.code ? '/' : currLanguage.base_url;
	});
</script>
